import React from 'react';
import { useSelector } from 'react-redux';

import {
  seoStateSelector,
  flightSearchDataSelector,
  faqsSelector
} from '@stencil/flights-seo-reducers/src/SRP/redux/selectors';
import FAQs from '@stencil/commonstories/src/components/Seo/faqs/faqs';
import AboutCity from '@stencil/commonstories/src/components/Seo/about-city/about-city';
import MainInformation from '@stencil/commonstories/src/components/Seo/main-information/main-information';
import BreadCrumbs from '@stencil/commonstories/src/components/Seo/breadcrumbs/breadcrumbs';
import FareTable from '@stencil/commonstories/src/components/Seo/fare-table/fare-table';
import { FLIGHTS_TEXT, TO } from '@stencil/flights-constants/src/text';
import insertAnElementIntoArrayAtSpecificIndex from '@stencil/flights-utils/src/insert-an-element-into-array-at-specific-index';

import FareTrendsContainer from '../fare-trends/seo-dweb-fare-trends';
import SeoSrpList from '../seo-srp-list/seo-srp-list';
import FareOptions from '../fare-options/fare-options';

const SrpSeoRight = ({ fetchFareCalendareData }) => {
  const seoState = useSelector(seoStateSelector);
  const flightSearchData = useSelector(flightSearchDataSelector);
  const faqs = useSelector(faqsSelector);
  const {
    src,
    dest,
    source,
    destination,
    departure,
    srcArticle,
    destArticle,
    meta_description,
    write_up,
    minfare,
    flightInfo,
    h_1_header,
    queryType,
    language,
    airlineInfo = {},
    ifTemplateLevelContent,
    extraContent,
    extraContentPosition,
    breadcrumb,
    flight_info
  } = seoState;

  const isHindi = language === 'hindi' ? true : false;
  const srcName = src ? (isHindi && src.hindi_name ? src.hindi_name : src.name) : source.city;
  const destName = dest
    ? isHindi && dest.hindi_name
      ? dest.hindi_name
      : dest.name
    : destination.city;
  const { about_airline } = airlineInfo;
  const airlineName =
    isHindi && airlineInfo.hindi_name ? airlineInfo.hindi_name : airlineInfo.name || '';
  const isFlightSchedule = queryType && queryType.includes('flight-schedule') ? true : false;
  const isRoute = queryType === 'flights' || queryType === 'international-flights' ? true : false;

  let routeInfoElements = [
    ...(minfare && minfare.minToday
      ? [
          <FareTable
            title={`${srcName} ${destName} Cheap Flights`}
            minfare={minfare}
            flightSearchData={flightSearchData}
            isDweb={true}
          />
        ]
      : []),
    ...(breadcrumb ? [<BreadCrumbs breadcrumb={breadcrumb} isDweb={true} />] : []),
    ...(flightInfo && flightInfo.api_url
      ? [<MainInformation seoContent={flightInfo.api_url} isDweb={true} />]
      : []),
    ...(ifTemplateLevelContent && ifTemplateLevelContent.api_url
      ? [<MainInformation seoContent={ifTemplateLevelContent.api_url} isDweb={true} />]
      : []),
    ...(flight_info ? [<AboutCity longDesc={flight_info} isDweb={true} />] : []),
    ...(srcArticle && srcArticle.long_desc && !isFlightSchedule
      ? [<AboutCity title={srcArticle.title} longDesc={srcArticle.long_desc} isDweb={true} />]
      : []),
    ...(destArticle && destArticle.long_desc && !isFlightSchedule
      ? [<AboutCity title={destArticle.title} longDesc={destArticle.long_desc} isDweb={true} />]
      : []),
    ...(about_airline
      ? [<AboutCity title={`About ${airlineName}`} longDesc={about_airline} isDweb={true} />]
      : []),
    ...(faqs && faqs.length
      ? [
          <FAQs
            faqs={faqs}
            isDweb={true}
            sector={`${srcName} ${TO[language]} ${destName} ${FLIGHTS_TEXT[language]}`}
          />
        ]
      : []),
    ...(isFlightSchedule ? [<AboutCity title="" longDesc={meta_description} isDweb={true} />] : [])
  ];
  routeInfoElements = extraContent
    ? insertAnElementIntoArrayAtSpecificIndex(
        routeInfoElements,
        extraContentPosition,
        <AboutCity title="" longDesc={extraContent} isDweb={true} />
      )
    : routeInfoElements;

  return (
    <>
      <AboutCity
        title={h_1_header}
        longDesc={write_up}
        isDweb={true}
        shouldBeH1={true}
        isH1Header={true}
      />
      <FareOptions />
      <FareTrendsContainer getFareData={fetchFareCalendareData} />
      <SeoSrpList isRoute={isRoute} />
      {routeInfoElements.map((element, index) => {
        return <div key={index}>{element}</div>;
      })}
    </>
  );
};

export default SrpSeoRight;
